module.exports = __webpack_public_path__ + "img/kiko-flying.2b6033b2.gif";